import React from 'react';

import { useIntl } from 'react-intl-next';

import { Pressable, xcss } from '@atlaskit/primitives';
import { components } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';
import { type TimingMenuListProps } from './types';

const footerButtonStyles = xcss({
	borderTopColor: 'color.border',
	borderTopStyle: 'solid',
	borderTopWidth: 'border.width',
	textAlign: 'left',
	width: '100%',
	font: token('font.body'),
	fontWeight: token('font.weight.medium'),
	paddingBlock: 'space.075',
	paddingInline: 'space.150',
	color: 'color.text',
	backgroundColor: 'color.background.neutral.subtle',

	':hover': {
		backgroundColor: 'color.background.neutral.subtle.hovered',
	},
	':active': {
		backgroundColor: 'color.background.neutral.subtle.pressed',
	},
});

const TimingMenuList: React.FC<TimingMenuListProps> = ({ onCustom, ...menuListProps }) => {
	const intlApi = useIntl();

	return (
		<>
			<components.MenuList {...menuListProps}>{menuListProps.children}</components.MenuList>
			<Pressable onClick={onCustom} xcss={footerButtonStyles}>
				{intlApi.formatMessage(messages.createCustomDuration)}
			</Pressable>
		</>
	);
};

export { TimingMenuList };
